import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    relatedAssignmentIds: Array
  }

  disconnect() {
    this.clearHighlight()
  }

  highlight() {
    this.relatedAssignmentIdsValue.forEach((assignmentId) => {
      this.samePlanAssignmentElements(assignmentId).forEach((element) => {
        element.classList.add(...this.highlightClasses)
      })
    })
  }

  clearHighlight() {
    this.relatedAssignmentIdsValue.forEach((assignmentId) => {
      this.samePlanAssignmentElements(assignmentId).forEach((element) => {
        element.classList.remove(...this.highlightClasses)
      })
    })
  }

  samePlanAssignmentElements(assignmentId) {
    return document.querySelectorAll(`[data-assigned-job-id="${assignmentId}"]`)
  }

  get highlightClasses() {
    return [
      "ring-2",
      "ring-amber-300",
      "dark:ring-amber-400",
      "bg-amber-50/60",
      "dark:bg-amber-900/20"
    ]
  }
}
